<template>
  <div />
</template>

<script>

export default {
  name: 'compression-action',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'COMPRESSION',
        id: 'CPR',
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
</style>
